<template>
  <VCard
    flat
    class="d-flex flex-column"
    style="height: 100%; max-height: 100%"
  >
    <VCardTitle class="cart-notification-header d-flex align-center pa-3">
      <slot name="header" />
      <VSpacer />
      <VBtn
        v-if="!hideCloseButton"
        data-testid="cart-notification-close"
        class="cart-notification-close"
        :aria-label="$t('dialog.close.aria-label')"
        variant="text"
        icon
        size="small"
        @click="close"
      >
        <VIcon>{{ icons.mdiClose }}</VIcon>
      </VBtn>
    </VCardTitle>
    <VDivider class="mx-3" />

    <!-- needs class scrollable-container to be able to reset to top when scrolled -->
    <VCardText class="overflow-y-auto px-3 scrollable-container">
      <slot name="content" />
      <template v-if="recommendedProducts.length">
        <p class="mt-8 mb-0 font-weight-bold">
          {{ $t('label.recommendedItems') }}
        </p>
        <RecommendedProducts
          :products="recommendedProducts"
          :source="AddToCartSource.RECOMMENDED_PRODUCTS"
          hide-wishlist
          cols="6"
          :sizes="CART_DRAWER_CARD_SIZES"
          wrap
          class="mt-2"
        />
      </template>
    </VCardText>
    <VCardActions v-if="$slots.action" class="mt-3 pa-3 pt-0 elevation-4">
      <slot name="action" />
    </VCardActions>
  </VCard>
</template>

<script lang="ts" setup>
import { mdiClose } from '@mdi/js'
import RecommendedProducts from '~/components/base/ProductLoadMore.vue'
import { useShopStore } from '~/stores/shop'
import { useNotificationsStore } from '~/stores/notifications'
import { NotificationEventState } from '~/types/notifications'
import { AddToCartSource } from '~/stores/cart'
import { CART_DRAWER_CARD_SIZES } from '~/utils/format/imageSizes'

const icons = { mdiClose }

withDefaults(defineProps<{
  hideCloseButton?: boolean
}>(), {
  hideCloseButton: false
})

const shopStore = useShopStore()
const recommendedProducts = computed(() => shopStore.recommendedProductsList)

const notificationsStore = useNotificationsStore()
const close = () => {
  notificationsStore.replace({
    state: NotificationEventState.NotificationClose
  })
}
</script>

<style lang="scss" scoped>
.scrollable-container {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.cart-notification-header {
  height: 53px;
}

.cart-notification-close {
  width: 28px;
  min-width: 0;
  height: 28px;
  padding: 0;
  border-radius: 50%;
}
</style>
